module.exports = __webpack_public_path__ + "static/media/tournament-builder-screenshot.bce299e4.png";